import styled from 'styled-components';

export const TemperatureItem = styled.div`
  pointer-events: none;
  transform: translateY(-${props => props.item.ui.fontSize});
  line-height: 126%;
  letter-spacing: 0.5px;
  margin: 0;
  padding: 0;
  border: 0;
  overflow: hidden;
  display: table;
  background-color: transparent;
  font-family: ${props => props.item.ui.fontFamily};
  font-size: ${props => props.item.ui.fontSize};
  color: ${props => props.item.ui.fontColor};
`;

export default TemperatureItem;
